import { render, staticRenderFns } from "./CloseReturnModal.vue?vue&type=template&id=6e281810"
import script from "./CloseReturnModal.vue?vue&type=script&lang=js"
export * from "./CloseReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports